import * as legendActions from '../../actions/legendActions';
import * as textActions from '../../actions/textActions';
import * as chartActionTypes from '../../constants/chart-action-types';
import * as utils from './headings.utils';

const initialState = {
  slug: '',
  mustRender: false,
  title: { text: '', enabled: true },
  dek: { text: '', enabled: true },
  subdek: { text: '', enabled: true },
  note: { text: 'Note: ', enabled: false },
  source: { text: 'Source: ', enabled: true },
  date: { text: '', enabled: false },
  xaxisTitle: { text: '', enabled: true },
  yaxisTitle: { text: '', enabled: true },
  subdekPromo: { text: '', enabled: false },
  notePromo: { text: 'Note: ', enabled: false },
  sourcePromo: { text: 'Source: ', enabled: false },
  altText: { text: '', modifiedByUser: false, prevProp: null },
  chartFont: 'en',
};

function headingsReducer(state = initialState, action) {
  const { payload, stateTree, enabled } = action;

  switch (action.type) {
    case chartActionTypes.DESTROY_CHART:
      return initialState;
    case legendActions.MUST_RENDER_FALSE:
      return { ...state, mustRender: payload };
    case chartActionTypes.RECEIVE_CHART:
      return utils.fetchHeadingsInfo(state, action);
    case textActions.UPDATE_TITLE:
      return utils.updateChart(stateTree, state, payload, 'title');
    case textActions.UPDATE_DEK:
      return utils.updateChart(stateTree, state, payload, 'dek');
    case textActions.UPDATE_SUBDEK:
      return utils.updateChart(stateTree, state, payload, 'subdek');
    case textActions.UPDATE_NOTE:
      return utils.updateChart(stateTree, state, payload, 'note');
    case textActions.UPDATE_SOURCE:
      return utils.updateChart(stateTree, state, payload, 'source');
    case textActions.UPDATE_DATE:
      return utils.updateChart(stateTree, state, payload, 'date', enabled);
    case textActions.UPDATE_XAXISTITLE:
      return utils.updateChart(stateTree, state, payload, 'xaxisTitle');
    case textActions.UPDATE_YAXISTITLE:
      return utils.updateChart(stateTree, state, payload, 'yaxisTitle');
    case textActions.UPDATE_SLUG:
      return utils.updateChart(stateTree, state, payload, 'slug');
    case textActions.UPDATE_SUBDEKPROMO:
      return utils.updateChart(stateTree, state, payload, 'subdekPromo');
    case textActions.UPDATE_NOTEPROMO:
      return utils.updateChart(stateTree, state, payload, 'notePromo');
    case textActions.UPDATE_SOURCEPROMO:
      return utils.updateChart(stateTree, state, payload, 'sourcePromo');
    case textActions.UPDATE_ALT_TEXT:
      return utils.updateChart(stateTree, state, payload, 'altText');
    case textActions.UPDATE_CHART_FONT:
      return utils.updateChart(stateTree, state, payload, 'chartFont');
    default:
      return state;
  }
}

export default headingsReducer;
